import type { BasemapTone } from '../basemaps'

/**
 * The colour lines and barbs are drawn in, by the basemap under them.
 *
 * Isobars, height contours and barbs are ink over geography rather than data
 * colours, and ink has to contrast with the ground. Dark ink was right for
 * Positron and is invisible on the dark basemap, which Phase 10 made the
 * default under the dark theme. So the ink is a property of the *basemap*, not
 * of the app's theme: somebody on the light theme who picks the dark map needs
 * light lines too.
 *
 * Module state, set by `createMap` before every style load, for the same
 * reason the frame budgets are: a vector layer reads it when it adds itself,
 * and a basemap switch re-adds every layer on the new style's `style.load`.
 */

export interface Ink {
  line: string
  bold: string
  barb: string
}

const INK: Record<BasemapTone, Ink> = {
  light: { line: '#1f2933', bold: '#0b1116', barb: '#16222e' },
  dark: { line: '#d9dee4', bold: '#f5f7f9', barb: '#e6eaef' },
}

let tone: BasemapTone = 'light'

export function setInkTone(next: BasemapTone): void {
  tone = next
}

export function inkTone(): BasemapTone {
  return tone
}

export function ink(): Ink {
  return INK[tone]
}
